export const coursePerformanceAnalyticsHeader = [
  { field: 'sl_no', headerName: 'Sl No.', width: 80 },
  { field: 'course_name', headerName: 'Course', width: 180 },

  { field: 'active_students_from_date', headerName: 'Active Students on From Date', width: 220 },
  { field: 'paying_students', headerName: 'Paying Students', width: 160 },
  { field: 'active_tutors_from_date', headerName: 'Active Tutors on From Date', width: 220 },
  { field: 'student_tutor_ratio', headerName: 'Student Tutor Ratio', width: 180 },

  { field: 'revenue', headerName: 'Revenue', width: 140 },
  { field: 'arpu', headerName: 'ARPU', width: 120 },
  { field: 'arppu', headerName: 'ARPPU', width: 120 },

  { field: 'total_tp', headerName: 'Total TP', width: 120 },
  { field: 'sessions_held', headerName: 'Sessions Held', width: 160 },
  { field: 'average_tp', headerName: 'Average TP', width: 140 },

  { field: 'gross_profit', headerName: 'Gross Profit', width: 160 },
  { field: 'gross_margin', headerName: 'Gross Margin', width: 160 },

  { field: 'paying_student_rate', headerName: 'Paying Student Rate', width: 190 },
  { field: 'tc_uploaded', headerName: 'TC Uploads', width: 140 },

  { field: 'reactivations_from_inactive', headerName: 'No. of Reactivations from Inactive', width: 260 },
  { field: 'tcs_from_inactive', headerName: 'No. of TCs from Inactive', width: 240 },

  { field: 'active_students_to_date', headerName: 'Active Students on To Date', width: 220 },
  { field: 'active_tutors_to_date', headerName: 'Active Tutors on To Date', width: 220 },
];
